type Props = {
  avgSeconds: number;
  p0: number;
  p25: number;
  p50: number;
  p75: number;
  p95: number;
};

const formatTime = (seconds: number): string => {
  if (seconds < 60) {
    return `${Math.round(seconds)}s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return `${minutes}m ${remainingSeconds}s`;
};

const ResponseTimeMetricsCard = ({ p25, p50, p75 }: Props) => {
  return (
    <div className="h-full rounded-2xl border border-border bg-card p-6">
      <h3 className="mb-4 text-sm font-semibold text-palomma-secondary">
        Tiempo de respuesta del agente
      </h3>

      <div className="mb-4 rounded-xl bg-palomma-primary p-4 text-white">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium">Tiempo típico de respuesta</p>
          <p className="text-2xl font-bold">{formatTime(p50)}</p>
        </div>
      </div>

      <p className="text-sm text-muted-foreground">
        Rango típico {formatTime(p25)}–{formatTime(p75)}
      </p>
    </div>
  );
};

export default ResponseTimeMetricsCard;
